// AccountHubPage — Profile, KYC, country, about

import { HubLayout } from './HubLayout';

export function AccountHubPage() {
  return (
    <HubLayout
      title="Account"
      testIdRoot="hub-account"
      hero={{
        title: 'Your account',
        subtitle: 'Profile, identity, region',
        emoji: '👤',
        gradient: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)',
        stats: [
          { label: 'KYC',     value: '✓',     sub: 'verified', color: '#34C759' },
          { label: 'Member',  value: '4 mo',  sub: 'since Apr' },
          { label: 'Country', value: '🇺🇸',   sub: 'United States' },
        ],
      }}
      quickActions={[
        { to: '/portal/profile-edit', label: 'Edit profile', icon: '✏️', testId: 'hub-account-qa-edit' },
        { to: '/portal/kyc-flow',     label: 'Verify KYC',   icon: '🛡️', testId: 'hub-account-qa-kyc' },
        { to: '/portal/country',      label: 'Country',      icon: '🌍', testId: 'hub-account-qa-country' },
      ]}
      sections={[
        {
          title: 'Profile',
          items: [
            { to: '/portal/profile',       icon: '👤', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'View profile',     sub: 'demo@funderpro.live' },
            { to: '/portal/profile-edit',  icon: '✏️', iconBg: 'linear-gradient(135deg, #007AFF 0%, #5856D6 100%)', label: 'Edit profile',     sub: 'Name, bio, photo' },
            { to: '/portal/showcase',      icon: '🌟', iconBg: 'linear-gradient(135deg, #FFD60A 0%, #FF9500 100%)', label: 'Public showcase',  sub: 'Your trader profile' },
            { to: '/portal/affiliate',     icon: '🔗', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Affiliate program', sub: 'Custom referral code' },
            { to: '/portal/onboarding',    icon: '🚀', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Onboarding',        sub: 'Re-walk through setup' },
          ],
        },
        {
          title: 'Identity & Region',
          items: [
            { to: '/portal/kyc-flow',      icon: '🛡️', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Verify identity (KYC)', sub: 'Verified · 2026-04-12', badge: { text: 'Done', color: 'white', bg: '#34C759' } },
            { to: '/portal/kyc',           icon: '🪪', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'KYC status',        sub: 'Documents & status' },
            { to: '/portal/country',       icon: '🌍', iconBg: 'linear-gradient(135deg, #007AFF 0%, #5856D6 100%)', label: 'Country & tax',     sub: 'United States · USD' },
          ],
        },
        {
          title: 'About',
          items: [
            { to: '/portal/about',         icon: 'ℹ️', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'About Funder Pro', sub: 'Malta · C 104558 · v3.2.1' },
            { to: '/portal/feedback',      icon: '💌', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Send feedback',    sub: 'Help us improve' },
            { to: '/portal/disclosures',   icon: '📋', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Legal disclosures', sub: 'Terms · Privacy · Risk' },
          ],
        },
      ]}
    />
  );
}
